<div class="grid" *ngIf="!isIgnoreHeader">
  <div class="col-6 md:col-6 lg:col-6">
    <div class="breadcrumb-nav">
    <span class="breadcrumb-link" (click)="navigateBack()">{{parentUrl | titlecase}} </span>
    <span class="breadcrumb-separator"> / </span>
    <span class="breadcrumb-current"> {{ headerStr }}</span>
    <div class="page-title-col">
         <h1 class="page-title"><span class="back-arrow" (click)="navigateBack()">
          <i class="pi pi-arrow-left" style="cursor: pointer;"></i>
        </span> {{headerStr}}</h1>
    </div>
  </div>
  </div>
  <!-- <div class="col-12 md:col-6 lg:col-6">
    <div class="bread-crumbs">
      <li class="bread-item" *ngFor='let bread of breadCrumArray'>
        <a href="{{bread.url}}"> &nbsp;{{bread.name}}</a>
      </li>
    </div>
  </div> -->
</div>